import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Title from "../title";
import { setMembershipCardsScannerPopupOpen } from "../../redux/actions/membershipCard/membershipCardAction";
import { ComonIcons } from "../../contents/commonIcons";
import { FormGroup, Input, Label } from "reactstrap";
import SpinnerComponent from "../spinner/spinner";
import { addUserModal } from "../../redux/actions/sidebar/sidebarAction";
import { history } from "../../app/AppRouter";
import { getGymMemberByMembershipCardNumber } from "../../redux/actions/api/apiAction";
import { setRFIDCardIdValue, setMemberGymByMembershipCardId } from "../../redux/actions/membershipCard/membershipCardAction";
import { toastr } from "react-redux-toastr";
import { store } from "../../redux/storeConfig/store";

export const MembershipCardsScannerPopup = ({ }) => {
  const { membershipCardsScannerPopupOpen, membershipCardsScannerAction, RFIDCardId, memberGymByMembershipCardId } = useSelector(state => state.membershipCard);
  const { userModal } = useSelector(state => state.sidebar);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [localRFID, setLocalRFID] = useState("");

  const toggle = () => {
    dispatch(setMembershipCardsScannerPopupOpen(!membershipCardsScannerPopupOpen));
  };

  // Only create RFID reader when popup is open
  useEffect(() => {
    if (membershipCardsScannerPopupOpen) {
      // Reset state when opening
      setLocalRFID("");
      dispatch(setRFIDCardIdValue(""));
      dispatch(setMemberGymByMembershipCardId(""));
      
      // Small delay to ensure popup is rendered before creating reader
      const timer = setTimeout(() => {
        createRFIDReader();
      }, 100);

      const keepRFIDReaderFocussing = (e) => {
        // Only focus if popup is open and click is not on search input
        if (e.target.id !== 'pos-search-input' && e.target.className?.indexOf('pos-search') === -1) {
          const RFIDReader = document.getElementById('cardIdRFIDReader');
          if (RFIDReader) {
            RFIDReader.focus();
            RFIDReader.select();
          }
        }
      };
      
      document.addEventListener('click', keepRFIDReaderFocussing);
      
      return () => {
        clearTimeout(timer);
        document.removeEventListener('click', keepRFIDReaderFocussing);
        deleteRFIDReader();
      };
    } else {
      // Cleanup when popup closes
      deleteRFIDReader();
      setLocalRFID("");
    }
  }, [membershipCardsScannerPopupOpen]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      deleteRFIDReader();
      dispatch(setMembershipCardsScannerPopupOpen(false));
    };
  }, []);

  const reset = () => {
    dispatch(setRFIDCardIdValue(""));
    dispatch(setMemberGymByMembershipCardId(""));
    deleteRFIDReader();
  };
  const createRFIDReader = () => {
    const RFIDReader = document.getElementById('cardIdRFIDReader');
    if (!RFIDReader) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.type = "text";
      input.id = "cardIdRFIDReader";
      input.autocomplete = "off";
      // Hide input but keep it focusable
      input.style.opacity = "0";
      input.style.position = "absolute";
      input.style.top = "-1000px";
      input.value = ""; // Ensure value is cleared
      input.focus();
      input.onchange = (e) => {
        const value = e.target.value?.trim();
        if (value) {
          dispatch(setRFIDCardIdValue(value));
          setLocalRFID(value);
        }
        input.value = "";
      }
    } else {
      RFIDReader.value = ""; // Clear any existing value
      RFIDReader.focus();
    }
  };
  const deleteRFIDReader = () => {
    const RFIDReader = document.getElementById('cardIdRFIDReader');
    return RFIDReader?.remove();
  };
  const checkCardHasGymMember = async (RFIDCardId) => {
    const member = await store.dispatch(getGymMemberByMembershipCardNumber(RFIDCardId));
    handleCardResponseRedirect(member);
  };
  const handleCardResponseRedirect = (user) => {
    setIsLoading(false);
    dispatch(setMembershipCardsScannerPopupOpen(false));
    if (membershipCardsScannerAction == "replace" || membershipCardsScannerAction == "searchByCardScanning" || membershipCardsScannerAction == "posCardScanning") {
      if (membershipCardsScannerAction == "searchByCardScanning" && !user) {
        toastr.error("Member not found!");
      }
      return;
    }
    if (user && user.id) {
      dispatch(setRFIDCardIdValue(""));
      dispatch(addUserModal(false));
      if (membershipCardsScannerAction == "add" || membershipCardsScannerAction == "addCardForExistingMember") {
        toastr.error("Membership Card already in use with another member, Invalid Card!");
      }
      //redirect to existing member profile page
      history.push(`/gym-panel/membersinfo/${user.id}`);
    } else {
      if (membershipCardsScannerAction == "addCardForExistingMember") {
        return;
      }
      //redirect to add new member popup
      if (!userModal) {
        dispatch(addUserModal(true));
      }
    }
  };

  useEffect(() => {
    if (localRFID) {
      deleteRFIDReader();
      setIsLoading(true);

      const start = async () => {
        //fetch gym member by card number
        checkCardHasGymMember(localRFID);
      };
      setTimeout(() => {
        start();
      }, 1000);
    }
  }, [localRFID]);


  return (
    <Modal
      isOpen={membershipCardsScannerPopupOpen}
      centered={true}
      size={"lg"}
      autoFocus={false}
      className="large-pop adding-popup"
    // toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Scan Member" />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="member-info-wrapper info-wrapper blk-padding-y" style={{ height: "50vh", maxHeight: "50vh", textAlign: "center" }}>
            {!localRFID && <div className="info-title">
              <Title title={"Ready For Scanning.."} />
            </div>}
            <div className="info trainer-info h-100">
              <Row style={{ flexDirection: "row", justifyContent: "center" }}>
                <Col md={6}>
                  <FormGroup className="custom-inputs">
                    <Input
                      type="text"
                      name="RFIDCardId"
                      id="RFIDCardId"
                      maxLength={50}
                      disabled={true}
                      value={localRFID}
                      className={`form-control`}
                    />
                    <Label for="RFIDCardId" className="">
                      Card Number
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              {isLoading &&
                <div
                  className="d-flex flex-column align-items-center justify-content-center h-50">
                  <SpinnerComponent />
                  <h3>Please wait</h3>
                </div>
              }
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}